import { reducer as generalNotificationReducer } from '../components/SharedComponents/GeneralNotification';
import { reducer as dialogToastReducer } from '../components/SharedComponents/DialogToast';
import { reducer as parameterBackupReducerV2 } from '../components/PowertrainAssetDetails/DetailedInformation/Header/ParameterBackupV2';
import { reducer as ChangedParameterListReducerV2 } from '../components/PowertrainAssetDetails/DetailedInformation/Header/ChangedParameterListV2';
import { reducer as overviewReducer } from '../components/PowertrainOverview';
import { reducer as generalFilterReducer } from '../components/GeneralFilter';
import { reducer as generalFilterEditReducer } from '../components/GeneralFilter/GeneralFilterModal/GeneralFilterEdit';
import { reducer as assetDetailsInfoHeaderReducer } from '../components/PowertrainAssetDetails/DetailedInformation/AssetDetails/Header';
import { reducer as assetNameplateImageHolderReducer } from '../components/PowertrainAssetDetails/DetailedInformation/AssetDetails/Header/AssetNameplateImageHolder';
import { reducer as assetPhysicalConnectionReducer } from '../components/PowertrainAssetDetails/DetailedInformation/AssetDetails/Header/AssetPhysicalConnection';
import { reducer as eventLogReducer } from '../components/PowertrainAssetDetails/DetailedInformation/EventLog';
import { reducer as sensorPropertiesReducer } from '../components/PowertrainAssetDetails/DetailedInformation/SensorProperties';
import { reducer as portalReducer } from '../components/Portal';
import { reducer as powertrainAssetDetailsReducer } from '../components/PowertrainAssetDetails';
import { reducer as detailedInformationHeaderReducer } from '../components/PowertrainAssetDetails/DetailedInformation/Header';
import { reducer as operationalParametersReducer } from '../components/PowertrainAssetDetails/DetailedInformation/OperationalParametersV2';

import { reducer as detailedInformationReducer } from '../components/PowertrainAssetDetails/DetailedInformation';
import { reducer as assetAndPowetrainFilterReducer } from '../components/PowertrainAssetDetails/DetailedInformation/AssetAndPowertrainFilter';
import { reducer as eventDetailsCMDReducer } from '../components/PowertrainAssetDetails/DetailedInformation/EventLog/EventDetails/EventDetailsCMD';
import { reducer as notificationStatusBarReducer } from '../components/PowertrainAssetDetails/DetailedInformation/NotificationStatusBar';
import { reducer as eventDetailsSSReducer } from '../components/PowertrainAssetDetails/DetailedInformation/EventLog/EventDetails/EventDetailsSS';
import { reducer as bulkUploadV2 } from '../components/PowertrainAssetDetails/DetailedInformation/Header/BulkUploadV2';
import { reducer as muteAsset } from '../components/PowertrainAssetDetails/DetailedInformation/Header/MuteAsset';
import { reducer as LimitConfigReducer } from '../components/PowertrainAssetDetails/DetailedInformation/LimitConfigurationBeta';
import { reducer as selfFaultEvaluationReducer } from '../components/PowertrainAssetDetails/DetailedInformation/EventLog/EventDetails/EventDetailsCMD/SelfFaultEvaluation';
import { reducer as crossAssetAnalysisSidepanelReducer } from '../components/PowertrainAssetDetails/CrossAssetAnalysis/CrossAssetAnalysisSidepanel';
import { reducer as crossAssetAnalysisV2Reducer } from '../components/PowertrainConditionMonitoring/CrossAssetAnalysisV2';
import { reducer as eventDetailsTrendSignalReducer } from '../components/PowertrainAssetDetails/DetailedInformation/EventLog/EventDetails/EventDetailsCMD/TrendSignal';
import { reducer as chartViewReducer } from '../components/PowertrainAssetDetails/CrossAssetAnalysis/ChartView/';
import { reducer as powertrainAssetOverviewReducer } from '../components/PowertrainConditionMonitoring/PowertrainsAssetsOverview/';
import { reducer as powertrainToolsReducer } from '../components/PowertrainTools';
import { reducer as reportIssueModalReducer } from '../components/PowertrainOverview/Header/ReportIssueModal';
import { reducer as reportsReducer } from '../components/Reports';
import { reducer as assetConditionInsightsReducer } from '../components/PowertrainAssetDetails/DetailedInformation/ConditionInsights/ConditionInsightsReducer';
import { reducer as notificationSettingsReducer } from '../components/UserProfileSettings/NotificationSettings';
import { reducer as switchOrganizationReducer } from '../components/SwitchOrganizationModal';
import { reducer as downloadMeasurementsReducer } from '../components/PowertrainAssetDetails/DetailedInformation/Header/DownloadMeasurements';
import { reducer as notificationPanelReducer } from '../components/PowertrainOverview/Header/NotificationDropdown';
import { reducer as dataLoggerCommandsReducer } from '../components/PowertrainAssetDetails/DetailedInformation/Header/DataLogger';
import { reducer as advancedAnalyticsReducerV2 } from '../components/PowertrainAssetDetails/DetailedInformation/AdvancedAnalyticsV2';
import { reducer as conditionIndicesReducerV2 } from '../components/PowertrainConditionMonitoring/ConditionIndicesOverviewV2';
import { reducer as assetOverviewReducerV2 } from '../components/PowertrainConditionMonitoring/AssetOverviewDeatilsV2';
import { reducer as maintenanceOverviewReducerV2 } from '../components/PowertrainConditionMonitoring/MaintenanceOverviewV2';
import { reducer as fleetsDashboardReducer } from '../components/PowertrainFleets/FleetsDashboard';
import { reducer as fleetOverviewReducer } from '../components/PowertrainFleets/FleetOverview';


export const reducers = {
    changedParametersV2: ChangedParameterListReducerV2,
    overview: overviewReducer,
    generalFilter: generalFilterReducer,
    generalFilterEdit: generalFilterEditReducer,
    powertrainAssetDetails: powertrainAssetDetailsReducer,
    sensorProperties: sensorPropertiesReducer,
    downloadMeasurements: downloadMeasurementsReducer,
    limitConfig: LimitConfigReducer,
    assetDetailsInfoHeader: assetDetailsInfoHeaderReducer,
    assetPhysicalConnection: assetPhysicalConnectionReducer,
    eventLog: eventLogReducer,
    selfFaultEvaluation: selfFaultEvaluationReducer,
    muteAsset: muteAsset,
    portal: portalReducer,
    operationalParameters: operationalParametersReducer,
    generalNotification: generalNotificationReducer,
    dialogToast: dialogToastReducer,
    detailedInformationHeader: detailedInformationHeaderReducer,
    detailedInformation: detailedInformationReducer,
    assetAndPowetrainFilter: assetAndPowetrainFilterReducer,
    eventDetailsCMD: eventDetailsCMDReducer,
    eventDetailsSS: eventDetailsSSReducer,
    notificationStatusBar: notificationStatusBarReducer,
    bulkUploadV2,
    crossAssetAnalysisSidepanel: crossAssetAnalysisSidepanelReducer,
    crossAssetAnalysisV2: crossAssetAnalysisV2Reducer,
    eventDetailsTrendSignal: eventDetailsTrendSignalReducer,
    chartView: chartViewReducer,
    powertrainAssetOverview: powertrainAssetOverviewReducer,
    powertrainTools: powertrainToolsReducer,
    reports: reportsReducer,
    reportIssueModal: reportIssueModalReducer,
    assetNameplateImage: assetNameplateImageHolderReducer,
    assetConditionInsights: assetConditionInsightsReducer,
    notificationSettings: notificationSettingsReducer,
    switchOrganization: switchOrganizationReducer,
    notificationPanel: notificationPanelReducer,
    dataLoggerCommands: dataLoggerCommandsReducer,
    parameterBackupV2: parameterBackupReducerV2,
    advancedAnalyticsV2: advancedAnalyticsReducerV2,
    maintenanceOverviewV2: maintenanceOverviewReducerV2,
    conditionIndicesV2: conditionIndicesReducerV2,
    assetOverviewV2: assetOverviewReducerV2,
    fleetsDashboard: fleetsDashboardReducer,
    fleetOverview: fleetOverviewReducer,
};
